import React from 'react';
import { NavLink } from 'react-router-dom';
import logoImg from '../logo.svg';
import { Icon } from 'react-icons-kit';
import { menu } from 'react-icons-kit/feather/menu';
import { arrowLeft } from 'react-icons-kit/feather/arrowLeft'
import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { arrowUp } from 'react-icons-kit/feather/arrowUp';
import Sidebar from '../components/Sidebar';
import axios from 'axios';
import { useJwt } from "react-jwt";
import Tree from 'react-d3-tree';
import { CreateRole, GetAllProfile, GetAllRole, GetRoleTree } from '../apiconfig/authService';

function AddRole(props) {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem('accessToken'));
  if (isExpired)
    navigate('/');

  const setMediaTableViewMessage = props.setMessage;

  const [message, setMessage] = useState('');
  const [isMessageRed, setIsMessageRed] = useState('');


  const [roleName, setRoleName] = useState('');
  const [roleParentID, setRoleParentID] = useState('');
  const [roleProfileID, setRoleProfileID] = useState('');
  const [roleDescription, setRoleDescription] = useState('');
  const [treeData, setTreeData] = useState({});
  const [rolesData, setRolesData] = useState([]);
  const [profilesData, setProfilesData] = useState([]);



  const handleRoleNameChange = (e) => {
    setRoleName(e.target.value);
  };

  const handleRoleParentIDChange = (e) => {
    setRoleParentID(e.target.value);
  };

  const handleRoleProfileChange = (e) => {
    setRoleProfileID(e.target.value);
  };

  const handleRoleDescriptionChange = (e) => {
    setRoleDescription(e.target.value);
  };

  const validateInput = () => {
    if (roleParentID === '')
      throw new Error(`Select Role's Parent.`);
    if (roleName === '')
      throw new Error('Role Name is Required.');
    if (roleProfileID === '')
      throw new Error(`Select Role's Profile.`);
  };


  const handleSubmitClick = async (e) => {
    e.preventDefault();

    try {
      validateInput();
    } catch (error) {
      setIsMessageRed(true);
      setMessage(error.message);
      window.scrollTo(0, 0);
      return;
    }

    let response;

    try {
      response = await CreateRole({
        rolename: roleName,
        roledescription: roleDescription,
        roleparentid: roleParentID,
        roleprofileid: roleProfileID
      }, localStorage.getItem('accessToken'));
      if (response.status === 201) {
        setMediaTableViewMessage(response.data.message);
        navigate("/role");
      }
    } catch (err) {
      if ((err.response && err.response.data) && err.response.data.error) {
        setIsMessageRed(true);
        setMessage(err.response.data.error);
        window.scrollTo(0, 0);
      } else {
        setIsMessageRed(true);
        setMessage('An error occurred. Please try again later.');
        window.scrollTo(0, 0);
      }
    }
  };

  useEffect(() => {
    (
      async () => {
        try {
          const response = await GetRoleTree(localStorage.getItem('accessToken'));
          setTreeData(response.data);
        } catch (error) {
          console.log(error);
        }
      }
    )();
    (
      async () => {
        try {
          const response = await GetAllRole(localStorage.getItem('accessToken'));
          setRolesData(response.data);
        } catch (error) {
          console.log(error);
        }
      }
    )();
    (
      async () => {
        try {
          const response = await GetAllProfile(localStorage.getItem('accessToken'));
          setProfilesData(response.data);
        } catch (error) {
          console.log(error);
        }
      }
    )();
  }, []);

  return (
    <div className="dashboard-content">
      <Sidebar />
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Add Role</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/role" className="btn btn-primary">View All</NavLink>
          </div>
        </div>
        {message && <div style={{ color: isMessageRed ? 'red' : 'black' }} className="alert alert-primary" role="alert">{message}</div>}
        <div role="tabpanel" className="personal-info tab-pane active" id="pi">
          {/* <h4 className="text-primary h6 fw-bold mb-3">Product main category information</h4> */}
          <h4 className="text-primary h6 fw-bold">Roles Tree</h4>
          {treeData &&
            <div id="treeWrapper" style={{ width: '50em', height: '20em' }}>
              <Tree data={treeData} />
            </div>
          }
          <h4 className="text-primary h6 fw-bold">Role Information</h4>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="form-floating">
                <select className="form-select" value={roleParentID} onChange={handleRoleParentIDChange}>
                  <option value="">Select Parent</option>
                  {
                    rolesData?.map((item) => (
                      <option value={item.roleid}>
                        {item.rolename}
                      </option>
                    ))
                  }
                </select>
                <label htmlFor="floatingInput">Select Parent</label>
              </div>
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="form-floating mb-4">
                <input type="text" value={roleName} onChange={handleRoleNameChange} className="form-control" id="catName" placeholder="Product Main Category Name" />
                <label htmlFor="catName">Role Name</label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="form-floating">
                <select className="form-select" value={roleProfileID} onChange={handleRoleProfileChange}>
                  <option value="">Select Profile</option>
                  {
                    profilesData?.map((item) => (
                      <option value={item.profileid}>
                        {item.profilename}
                      </option>
                    ))
                  }
                </select>
                <label htmlFor="floatingInput">Select Role's Profile</label>
              </div>
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="form-floating mb-4">
                <input type="text" value={roleDescription} onChange={handleRoleDescriptionChange} className="form-control" id="catName" placeholder="Product Main Category Name" />
                <label htmlFor="catName">Role Description</label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-12 mb-3">
              <button type="submit" onClick={handleSubmitClick} className="btn btn-primary btn-lg save-btn text-uppercase">Add</button>
            </div>
          </div>
        </div>
        <hr />
      </div>
    </div>
  );
}
export default AddRole;
